export default {
  eyebrow: 'Portale partner',
  title: 'Fatturazione',
  description:
    'Il tuo metodo di pagamento per la fattura mensile della piattaforma e ogni fattura con il dettaglio completo.',
  toasts: {
    checkout_error: 'Impossibile avviare il checkout — riprova.',
    action_error: 'Azione non riuscita — riprova.',
    onboarding_error: 'Impossibile avviare la verifica: riprova.',
    payment_method_in_use:
      'Le licenze dei tuoi ristoranti sono fatturate su questo metodo di pagamento, quindi non può essere rimosso. Sostituiscilo con uno nuovo.',
  },
  payout_bank_account: {
    title: 'Conto bancario per i pagamenti',
    description:
      'I pagamenti della quota ricavi arrivano in {{currency}}. Stripe converte il trasferimento al suo arrivo.',
    toasts: {
      saved: 'Conto bancario salvato',
      save_failed: 'Non è stato possibile salvare il conto bancario. Controlla i dati.',
    },
  },
  payout_onboarding: {
    title: 'Configura il tuo account di pagamento',
    description:
      'La tua quota ricavi viene versata mensilmente su un account di pagamento Stripe. Completa la verifica una sola volta: i pagamenti restano sospesi finché non è conclusa.',
    missing: {
      title: 'Ancora necessario prima che i pagamenti possano iniziare:',
      bank_account: 'Aggiungi il conto bancario su cui deve essere versata la tua quota di ricavi.',
      business_details: 'Completa i dati della tua azienda, come indirizzo, partita IVA o numero di registrazione.',
      people: 'Aggiungi i dati del rappresentante, dei proprietari o degli amministratori della tua azienda.',
      documents: 'Carica i documenti di verifica richiesti da Stripe.',
      terms: 'Accetta i termini di servizio di Stripe.',
      other: 'Fornisci i dettagli rimanenti richiesti da Stripe.',
    },
    start: 'Avvia verifica',
    continue: 'Continua verifica',
    ready:
      'Account di pagamento verificato: la tua quota ricavi viene versata automaticamente dopo ogni ciclo di fatturazione.',
  },
  payment_method: {
    title: 'Metodo di pagamento',
    empty: 'Nessun metodo di pagamento registrato — la fattura mensile non può essere incassata automaticamente.',
    add: 'Aggiungi metodo di pagamento',
    replace: 'Sostituisci',
    remove: 'Rimuovi',
    remove_confirm: {
      title: 'Rimuovere questo metodo di pagamento?',
      description:
        'La carta/mandato viene rimosso da Stripe immediatamente. Senza un metodo di pagamento, le fatture — incluse quelle già emesse — vengono riscosse tramite la fattura Stripe ospitata anziché automaticamente.',
      confirm: 'Rimuovi',
    },
  },
  invoices: {
    title: 'Fatture',
  },
};
